import { put, takeEvery, call } from 'redux-saga/effects';
import Axios from 'axios';
import { message } from 'antd';

import Actions from '../action';
import { appConstant, apiUrl } from '@constants';
import { getAuthToken, getAuthKey, getKeyAndToken } from '@helpers';
import ActionsApp from '@sharedComponent/app-action-reducer/action';

export function* affiliateCommissionSummaryWorker({ request, history }) {
	const { authKey, authToken } = getKeyAndToken();
	try {
		const uri = `${appConstant.domain + apiUrl.GET_COMMISSION_SUMMARY + authKey}&fromDate=${request.fromDate}&toDate=${request.toDate}`;
		const res = yield call(Axios.get, uri, { headers: { Authorization: authToken } });
		yield put(Actions.creators.getAffiliateCommissionSummarySuccess(res.data.messages.result));
	} catch (err) {
		let mes = err.toString(err) === 'Error: Request failed with status code 400' ? appConstant.userNotExist : 'Something went wrong';
		message.error(mes);
		// yield put(ActionsApp.creators.removeUser(authKey, history));
		yield put(Actions.creators.getAffiliateCommissionSummaryFail());
	}
}

export default function* affiliateCommissionSummaryWatcher() {
	yield takeEvery(Actions.types.GET_AFFILIATE_COMMISSION_SUMMARY_STARTED, affiliateCommissionSummaryWorker);
}
